import { render, staticRenderFns } from "./subcontractor-settlement-drawer.vue?vue&type=template&id=2196c0b9&scoped=true"
import script from "./subcontractor-settlement-drawer.vue?vue&type=script&lang=js"
export * from "./subcontractor-settlement-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196c0b9",
  null
  
)

export default component.exports